import React from 'react';

export const WHATSAPP_URL = 'https://wa.me/5521984856295?text=Ol%C3%A1!%20Vim%20pelo%20site%20e%20gostaria%20de%20fazer%20um%20or%C3%A7amento.';

const WhatsAppButton = () => {
    return (
        <a className="whatsFloat" href={WHATSAPP_URL} target="_blank" rel="noreferrer" aria-label="Falar no WhatsApp">
            <img src={require('../assets/images/whatsApp.png')} alt="" />
            <span>Fale conosco</span>
        </a>
    );
};

export default WhatsAppButton;
